import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicantComponent } from './applicant/applicant.component';
import { AuthGuard } from './_core/guards/auth.guard';
import { PraticaComponent } from './pratica/pratica.component';
import { PresentationSheetComponent } from './presentation-sheet/presentation-sheet.component';
import { PraticaDetailComponent } from './pratica-detail/pratica-detail.component';
import { CourtesyPageComponent } from './core/components/courtesy-page/courtesy-page.component';
import { KpiTableComponent } from './_widgets/kpi-table/kpi-table.component';
import { PraticaGuard } from './_core/guards/pratica.guard';
import { SagittaScoreComponent } from './sagitta-score/sagitta-score.component';
import { ScoreGuard } from './_core/guards/score.guard';
import { AmlScoreComponent } from './aml-score/aml-score.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./home/home.module').then((module) => module.HomeModule),
      },

      {
        path: 'pratica/:idPratica',
        canActivate: [PraticaGuard],
        loadComponent: () => PraticaComponent,
        children: [
          {
            path: '',
            redirectTo: 'detail',
            pathMatch: 'full',
          },
          {
            path: 'detail',
            component: PraticaDetailComponent,
            children: [
              { path: '', redirectTo: 'applicant', pathMatch: 'full' },
              {
                path: 'applicant',
                loadComponent: () => ApplicantComponent,
              },
              {
                path: 'requests',
                loadChildren: () =>
                  import('./requests/requests.module').then(
                    (module) => module.RequestsModule
                  ),
              },
              {
                path: 'anagraphics',
                loadChildren: () =>
                  import('./anagraphics/anagraphics.module').then(
                    (module) => module.AnagraphicsModule
                  ),
              },
              {
                path: 'score',
                loadComponent: () => SagittaScoreComponent,
                canActivate: [ScoreGuard],
              },
              {
                path: 'aml-score',
                loadComponent: () => AmlScoreComponent,
                canActivate: [ScoreGuard],
              },
              {
                path: 'presentation-sheet',
                loadComponent: () => PresentationSheetComponent,
              },

              {
                path: 'documents',
                loadChildren: () =>
                  import('./documents/documents.module').then(
                    (module) => module.DocumentsModule
                  ),
              },
            ],
          },
          {
            path: 'questionario-qualitativo',
            loadComponent: () => KpiTableComponent,
          },
          {
            path: 'credit-score-crif',
            loadComponent: () => KpiTableComponent,
          },
          {
            path: 'analisi-andamentale',
            loadComponent: () => KpiTableComponent,
          },
          {
            path: 'analisi-bilancio',
            loadComponent: () => KpiTableComponent,
          },
          {
            path: 'analisi-garanzie',
            loadComponent: () => KpiTableComponent,
          },
          {
            path: 'score-kyc',
            loadComponent: () => KpiTableComponent,
          },
        ],
      },
      {
        path: 'employee-id',
        loadChildren: () =>
          import('./employee-id/employee-id.module').then(
            (module) => module.EmployeeIdModule
          ),
      },
    ],
  },
  { path: 'system-not-available', loadComponent: () => CourtesyPageComponent },
  //{ path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
